module.exports = __webpack_public_path__ + "img/in-use-ann-taboada@1x.14e312d4.jpg";